import produce from "immer";

const defaultState = {
    item: null,
    error: null,
    showGroupSwitch: false,
    groupSwitchTitle: null,
    groupSwitchOptions: []
};

export default function(state = defaultState, action) {
    switch (action.type) {
        case 'FETCH_REWARD':
            return {
                ...defaultState
            };
        case 'REWARD_FETCHED':
            return produce(state, draft => {
                draft.item = action.reward;
                draft.showGroupSwitch = action.reward.groupedRewards.length > 1;
                draft.groupSwitchTitle = action.reward.groupSwitchTitle;
                draft.groupSwitchOptions = action.reward.groupedRewards.map(gr => {return {"rewardId": gr.rewardId, "friendlyName": gr.friendlyName, "description": gr.groupSwitchDescription, "selected": gr.rewardId === action.reward.id}})
                draft.error = null;
            });
        case 'REWARD_NOT_FOUND':
            return produce(state, draft => {
                draft.item = null;
                draft.error = "REWARD_NOT_FOUND";
            });
        default:
            return state;
    }
}